const ChangeCalculator = require('@/libraries/DigiTickets/Payment/ChangeCalculator');
const EventNames = require('@/lib/Events/EventNames');
const Payment = require('@/lib/Payments/Payment');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');

/**
 * This is the controller for the inner part of the payment modal for the payment method of "Voucher".
 *
 * @param $scope
 * @param {CartService} cartService
 * @param {NumPadFactory} numPadFactory
 * @param {PaymentMethodService} paymentMethodService
 */
const VoucherCtrl = function VoucherCtrl(
    $scope,
    cartService,
    numPadFactory,
    paymentMethodService,
) {
    $scope.paymentMethodScopes[PaymentMethodRef.VOUCHER] = $scope;

    $scope.thisPaymentMethodRef = PaymentMethodRef.VOUCHER;
    $scope.thisPaymentMethod = paymentMethodService.getByRef($scope.thisPaymentMethodRef);

    $scope.cart = cartService;

    $scope.calculator = new ChangeCalculator();
    $scope.numPad = numPadFactory.create(
        {
            showCashButtons: true,
            showSignButton: false,
        }
    );
    $scope.numPad.onChange((value) => {
        // When the number pad value changes update the calculator.
        $scope.calculator.setAmountTendered(value);
        $scope.setNumPadTotal(value);
    });
    $scope.numPadListening = false;

    $scope.clear = function clear() {
        $scope.calculator.clear();
        $scope.numPad.clear();
    };

    $scope.setAmountDue = function setAmountDue(amount) {
        $scope.calculator.setAmountDue(amount);
        $scope.numPad.setExactAmount(amount);
        $scope.numPad.options.isNegative = amount < 0;
    };

    $scope.setAmountDue($scope.cart.getRemainingBalance());

    $scope.$on('payment-modal.payment-removed', function () {
        $scope.setAmountDue($scope.cart.getRemainingBalance());
    });

    $scope.$on('payment-modal.cancel-pressed', function (event, paymentMethodRef) {
        if (paymentMethodRef === $scope.thisPaymentMethodRef) {
            // Was cancelled from the cash tab.
            $scope.clear();
            $scope.setAmountDue($scope.cart.getRemainingBalance());
        }
    });

    $scope.$on(EventNames.PAYMENT_METHOD_CHANGED, function (event, newPaymentMethod) {
        const newPaymentMethodRef = newPaymentMethod?.ref;
        // Changing tab, so reset the calculator.
        $scope.clear();
        $scope.setAmountDue($scope.cart.getRemainingBalance());

        $scope.numPadListening = newPaymentMethodRef === $scope.thisPaymentMethodRef;
    });

    /**
     * This is called by the parent PaymentCtrl when the "received payment" button is clicked.
     * It is an opportunity to do something different than allowing the PaymentCtrl to generate a payment
     * for the remaining balance and add it to the cart.
     *
     * If this returns true it means we are intercepting the event, doing something special, and PaymentCtrl
     * should not generate and add its own payment.
     *
     * @return {boolean}
     */
    $scope.onPaymentReceivedPress = () => {
        if ($scope.cart.getSelectedPaymentMethodRef() !== $scope.thisPaymentMethodRef) {
            // We're not the active payment method. Do nothing.
            return false;
        }

        // If this is a cash payment, we need to check that the tendered
        // amount is higher than, or the same as, the amount required.
        if ($scope.calculator.getAmountTendered() > 0) {
            // For vouchers, we don't want to give any change, and don't want to create an overpayment.
            // So limit the voucher value to the max payment amount.
            let amount = Math.min(
                $scope.calculator.getAmountTendered(),
                $scope.cart.getRemainingMaxPayment()
            );

            let payment = new Payment();
            payment.setPaymentMethod($scope.thisPaymentMethod);
            payment.setTendered(amount);
            payment.setThirdPartyID($scope.cart.generatePaymentThirdPartyID());
            payment.setChangeGiven(0);
            payment.setValue($scope.calculator.getAmountTendered());
            $scope.addPayment(payment);
        }

        // Clear for next use.
        $scope.clear();
        $scope.setAmountDue($scope.cart.getRemainingBalance());

        return true;
    };
};

module.exports = VoucherCtrl;
